module.exports = __webpack_public_path__ + "static/media/lidingshan2.29962779.webp";